import React from 'react';
export function ArticleSummary() {
  return <div className="max-w-3xl mx-auto px-4 mb-12" data-id="element-203">
      <div className="bg-[#F3F4F6] border-l-4 border-[#2B4C7E] p-6 md:p-8 italic text-lg text-[#374151]" data-id="element-204">
        <h3 className="text-sm font-bold text-[#9CA3AF] uppercase tracking-wider mb-4 not-italic" data-id="element-205">
          Zusammenfassung des Artikels
        </h3>
        <p className="mb-4" data-id="element-206">
          "Was eine Frau aus Stuttgart entdeckte, nachdem sie jahrelang
          hochdosiertes Vitamin D einnahm:
        </p>
        <p className="mb-4" data-id="element-207">
          Eine persönliche Geschichte über die Gefahren der Selbstmedikation,
          das 'Kalzium-Paradoxon' und warum gute Blutwerte nicht immer bedeuten,
          dass man gesund ist.
        </p>
        <p className="font-medium text-[#1B1B2F]" data-id="element-208">
          — mit Kommentaren und wissenschaftlicher Einordnung von{' '}
          <span className="font-bold text-[#2B4C7E] not-italic" data-id="element-209">
            Dr. Lippert
          </span>
          , Experte für Alters-Ernährungsmedizin."
        </p>
      </div>
    </div>;
}